
import { group } from '@angular/animations';
import { ChangeDetectorRef, Component, ElementRef, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { PageBase, UIService, RentalObjectStatus, DamageInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';


@Component({
  styleUrls: ['./rentalObjectList.css'],
  selector: 'rentalObjectList',
  templateUrl: './rentalObjectList.html',
})

export class RentalObjectListComponent extends PageBase implements OnInit {
  constructor(el: ElementRef) {
    super(el, "RentalObjectList");
  }
  public loading: boolean = false;
  public rawData: any[] = [];


  async ngOnInit() {
    this.loading = true;

    this.rawData = await this.Api.get<any[]>("RentalObject/GetObjectsWithMissingAssets", {});

    this.loading = false;

  }

}

